import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';


export default function Documents() {
  const [agent, setAgent] = useState('')
  const [agentCode, setAgentcode] = useState('')
  const [modal, setModal] = useState(false)
  const [modal2, setModal2] = useState(false)
  const [file1, setFile1] = useState(null)
  const [file2, setFile2] = useState(null)
  const [file3, setFile3] = useState(null)
  const [uploadText, setUploadtext] = useState('Upload Documents')
  const [subfolders, setSubfolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [files, setFiles] = useState([]);
  const [credentials, setCredentials] = useState(null)
  const [isAuth, setIsauth] = useState(false)
  const company = 'Definite'


      useEffect(()=>{
      const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
      }
      getCredentials()
    
      },[])

  const handleFileChange1 = (e) => {
    setFile1(e.target.files[0]);
  };
  const handleFileChange2 = (e) => {
    setFile2(e.target.files[0]);
  };
  const handleFileChange3 = (e) => {
    setFile3(e.target.files[0]);
  };
  
  useEffect(() => {

  const user = localStorage.getItem('definiteagent'); // Retrieve email
  if (user) {
      
      setAgent(user)
  } else {
  
  }
  }, []);

  useEffect(()=>{
      const getAgentcode =async()=>{
          const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`);
          const data = await res.json();
          setAgentcode(data.OID)   

      }
      if(agent && isAuth){
          getAgentcode()
      }
  },[agent,isAuth])


  const toggle =()=>{
    setModal(true)
  }



        const handleUpload = async () => {
          setUploadtext('Please wait....')
          const folder = 'KYC'
          const formData = new FormData();
          formData.append('file', file1);
          formData.append('agent', agentCode);
          formData.append('proposal', folder);

           const formData2 = new FormData();
          formData2.append('file', file2);
          formData2.append('agent', agentCode);
          formData2.append('proposal', folder);

          const formData3 = new FormData();
          formData3.append('file', file3);
          formData3.append('agent', agentCode);
          formData3.append('proposal', folder);
        
      
          const requestOptions = {
                method: 'POST',
                body: formData
              };
      
          try {
      
           
            const response = await axios.post('https://digitalapi.definiteassurance.com/api/uploadIdentity', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              withCredentials:'false'
            } 
            );

             const response2 = await axios.post('https://digitalapi.definiteassurance.com/api/uploadIRA', formData2, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              withCredentials:'false'
            } 
            );

            const response3 = await axios.post('https://digitalapi.definiteassurance.com/api/uploadKRA', formData3, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              withCredentials:'false'
            } 
            );
            fetchSubfolders()
            toast.success('Documents uploaded')
            setUploadtext('Upload Documents')
            setModal(false)
           
          } catch (error) {
           //pass
          } finally {
             //pass
          }
        };
      const fetchSubfolders = async () => {
      try {
        const response = await fetch(`https://digitalapi.definiteassurance.com/api/subfolders/${agentCode}`);
        const data = await response.json();
        setSubfolders(data.subfolders || []);
      } catch (error) {
        console.error('Error fetching subfolders:', error);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
    const fetchSubfolders = async () => {
      try {
        const response = await fetch(`https://digitalapi.definiteassurance.com/api/subfolders/${agentCode}`);
        const data = await response.json();
        setSubfolders(data.subfolders || []);
      } catch (error) {
        console.error('Error fetching subfolders:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubfolders();
  }, [agentCode]);

   // Fetch files when a folder is clicked
  const handleFolderClick = async (folderName) => {
    setCurrentFolder(folderName);
    setLoading(true);
    try {
      const response = await fetch(
        `https://digitalapi.definiteassurance.com/api/files/${agentCode}/${folderName}`
      );
      const data = await response.json();
      setFiles(data.files || []);
      setModal2(true)
    } catch (error) {
      console.error('Error fetching files:', error);
    } finally {
      setLoading(false);
    }
  };

  // Function to open file in new tab
  const openFile = (fileName) => {
    const fileUrl = `https://digitalapi.definiteassurance.com/uploads/${agentCode}/${currentFolder}/${fileName}`;
    window.open(fileUrl, '_blank');
  };

   if (loading) return <div>Loading...</div>;
  
  return (
    <div className="page-content">
       <ToastContainer />
              <Breadcrumbs title="Definite Assurance" breadcrumbItem={`Documents`} />
              <Card className="mini-stats-wid">
                  <CardBody>
                    <Button color="success" onClick={toggle}>UPLOAD KYC's</Button>

                    <div className="documentsBody">

                       <div>
                        <h4 style={{marginTop:'3%'}}>Uploaded Documents</h4>
                        <hr />
                        {subfolders.length == 0 &&
                          <p>No documents uploaded!</p>
                        }
                        <div className="folders">
                            {subfolders.map((folder, index) => (
                                <div 
                                  key={index} 
                                  className="folder"
                                  onClick={() => handleFolderClick(folder)}
                                >
                                  <img className="folderImage" src="/folder.png" alt="" />
                                  <p>{folder}</p>
                                </div>
                              ))}
                        </div>
                        
                      </div>
                    </div>

                  </CardBody>
              </Card>
    


    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader>Upload KYC's Documents</ModalHeader>
      <div className="modalContainer">
          <p>IDENTIFICATION</p>
          <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="IDENTIFICATION" onChange={handleFileChange1} >
              <Form.Control  className='inputSearch' type="file" placeholder="IDENTIFICATION" />
          </FloatingLabel>

          <p>IRA CERTIFICATE</p>
          <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="IRA CERTIFICATE" onChange={handleFileChange2} >
              <Form.Control  className='inputSearch' type="file" placeholder="IRA CERTIFICATE" />
          </FloatingLabel>

          <p>KRA PIN</p>
          <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="KRA PIN" onChange={handleFileChange3} >
              <Form.Control  className='inputSearch' type="file" placeholder="KRA PIN" />
          </FloatingLabel>

          <Button style={{marginTop:'3%'}} color="success" onClick={handleUpload}>{uploadText}</Button>
          <p style={{color:'red',float:'right',marginTop:'3%',cursor:'pointer'}} onClick={()=>{setModal(false)}}>CLOSE</p>
      </div>
    </Modal>


      <Modal isOpen={modal2} size="lg" >
      <ModalHeader>{currentFolder} files</ModalHeader>
      <div className="modalContainer">
          {files.length > 0 ? (
          <ul className="files">
            {files.map((file, index) => (
              <li key={index} className="fileList">
                <span onClick={() => openFile(file)} style={{cursor: 'pointer'}}>
                  {file}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <p>No files found in this folder</p>
        )}
          
          <p style={{color:'red',float:'right',marginTop:'3%',cursor:'pointer'}} onClick={()=>{setModal2(false)}}>CLOSE</p>
      </div>
    </Modal>
    </div>
  )
}
